import { OpaccStaticContent } from './classes/opacc.class.staticcontent.js';

export const opaccStaticContentPlugin = new OpaccStaticContent();